<template>
  <div class="grid">
		<div class="col-12">
            <div class="card">
                <Toast/>
                <Error :errors="errors"/>

                <Fieldset legend="Add New" :toggleable="true" :collapsed="true" class="mb-3" v-if="permission.includes('create')">
                    <Create @submit="getDataTable()" ref="create"/>
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number" @sort="onSort($event)"  v-if="permission.includes('read')">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('xlsx')" v-if="permission.includes('download')"/>
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel" class="p-button p-button-success mr-2 my-1 inline-block" @click="exportExcelCSV('csv')" v-if="permission.includes('download')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Search..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="#" :style="{width:'20px'}" >
                        <template #body="slotProps">
                        {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="product_code" header="Code">
                        <template #body="slotProps">
                            {{slotProps.data.product_code}}
                        </template>
                    </Column>
                    <Column field="product_brand" header="Brand">
                        <template #body="slotProps">
                            {{slotProps.data.product_brand}}
                        </template>
                    </Column>
                    <Column field="product_name" header="Product Name">
                        <template #body="slotProps">
                            {{slotProps.data.product_name}}
                        </template>
                    </Column>
                    <Column field="product_category" header="Category">
                        <template #body="slotProps">
                            {{slotProps.data.product_category}}
                        </template>
                    </Column>
                    <Column field="product_type" header="Type">
                        <template #body="slotProps">
                            {{slotProps.data.product_type}}
                        </template>
                    </Column>
                    <Column field="flavour_name" header="Flavour">
                        <template #body="slotProps">
                            {{slotProps.data.flavour_name}}
                        </template>
                    </Column>
                    <Column field="uom" header="UOM">
                        <template #body="slotProps">
                            {{slotProps.data.uom}}
                        </template>
                    </Column>
                    <Column field="content" header="Content">
                        <template #body="slotProps">
                            {{slotProps.data.content}}
                        </template>
                    </Column>
                    <Column field="price_npr" header="NPR">
                        <template #body="slotProps">
                            {{formatNumber(slotProps.data.price_npr)}}
                        </template>
                    </Column>
                    <Column field="price_ptd" header="PTD">
                        <template #body="slotProps">
                            {{formatNumber(slotProps.data.price_ptd)}}
                        </template>
                    </Column>
                    <Column field="price_ptd_vat" header="PTD(VAT)">
                        <template #body="slotProps">
                            {{formatNumber(slotProps.data.price_ptd_vat)}}
                        </template>
                    </Column>
                    <Column field="price_ptr" header="PTR">
                        <template #body="slotProps">
                            {{formatNumber(slotProps.data.price_ptr)}}
                        </template>
                    </Column>
                    <Column field="price_ptr_vat" header="PTR(VAT)">
                        <template #body="slotProps">
                            {{formatNumber(slotProps.data.price_ptr_vat)}}
                        </template>
                    </Column>
                    <Column field="photo" header="Photo">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.photo">
                                <Image :src="slotProps.data.photo" :alt="slotProps.data.photo" width="100" preview />
                            </div>
                            <div v-else>
                                <Image src="/no_image.jpg" alt="No Image" width="100" preview />
                            </div>
                        </template>
                    </Column>
                    <Column field="product_status" header="Status">
                        <template #body="slotProps">
                            <Button icon="pi pi-check" class="p-button-rounded" v-if="slotProps.data.product_status == 'y'"/>
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger" v-else/>
                        </template>
                    </Column>
					<Column header="Action" headerStyle="min-width:10rem;">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editItem(slotProps.data, 'information')"  v-if="permission.includes('update')"/>
							<Button icon="pi pi-file" class="p-button-rounded p-button mr-2" @click="editItem(slotProps.data, 'pricing')"  v-if="permission.includes('update')"/>
						</template>
					</Column>
                    <template #empty>
                        No data found.
                    </template>
                    <template #loading>
                        Loading data. Please wait.
                    </template>
                    <template #footer>
                        In total there are {{totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount" :rowsPerPageOptions="[10,20,30]"  v-if="permission.includes('read')">
                    <template>
                        {{totalItemsCount}}
                    </template>
                </Paginator>

                <Edit @submit="getDataTable()" :item="item" ref="edit"/>

                <EditPricing @submit="getDataTable()" :item="item" ref="editPricing"/>
            </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { numberingDatatable } from '../../utils/helpers';
import Create from '../../components/master/product/Create.vue';
import Edit from '../../components/master/product/Edit.vue';
import EditPricing from '../../components/master/product/EditPricing.vue';
import Error from '../../components/Error.vue';

export default {
    components: {
		'Create': Create,
		'Edit': Edit,
		'EditPricing': EditPricing,
		'Error': Error,
	},
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            // edit
            item: {},
            
            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        }
    },
    mounted() {
        this.getDataTable();
        this.$store.commit('setErrors', {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed:{
        ...mapGetters(['errors']),

		...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value){
            if (value) {
                return moment.utc(value).format('DD-MM-YYYY')
            }
        },
        formatNumber(value){
            if (value) {
                return parseFloat(value).toFixed(2);
            }
        },
        // EDIT
		editItem(item, e) {
			this.item = item;

            if(e == 'information'){
                this.$refs.edit.editItemDialog = true;
            }else{
                this.$refs.editPricing.editItemDialog = true;
            }

		},
        // DATATABLE
        getDataTable(){
          
            this.loading=true;
            // this.$refs.filter.loading = true;
            this.page = (this.offset / this.rows) + 1;

            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/product',
                params: {
                    "search" : this.search,
                    "per_page" : this.rows,
                    "page" : this.page,
                    "order_by" : this.field,
                    "sort_by" : this.sort,
                }
            })
            .then(res => {
              this.data = res.data.data.data;
              this.dataTable = numberingDatatable(res.data.data.data, this.page, this.rows);
              this.totalItemsCount = res.data.data.total;
              this.rows = parseInt(res.data.data.per_page);
              this.loading=false;
            // this.$refs.filter.loading = false;
            })
            .catch((err) => {
                console.log(err);
                this.loading=false;
            // this.$refs.filter.loading = false;
            });
         
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == '1' ? 'ASC' : 'DESC';
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext){

            if(ext == 'xlsx'){
                this.loadingExcel=true;
            }else if(ext == 'csv'){
                this.loadingCsv=true;
            }

            this.axios({
            method: 'GET',
            url: process.env.VUE_APP_ROOT_API + 'web/product/export',
            responseType: 'blob',
            params: {
                "ext" : ext,
            }
            })
            .then(response => {
                let fileUrl = window.URL.createObjectURL(response.data);
                let fileLink = document.createElement('a');

                fileLink.href = fileUrl;

                fileLink.setAttribute('download', 'Product Export.' + ext);
                
                document.body.appendChild(fileLink)

                fileLink.click();
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }

            })
            .catch((err) => {
                console.log(err);
                
                if(ext == 'xlsx'){
                    this.loadingExcel=false;
                }else if(ext == 'csv'){
                    this.loadingCsv=false;
                }
            });
        },
    }
}
</script>
